import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import {environment} from './environments/environment';
import {enableProdMode} from "@angular/core";

// Disable console logs in production only; keep them for development builds
if (environment.production) {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
  console.error = () => {};
  enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
